import { render, staticRenderFns } from "./roomList.vue?vue&type=template&id=03858f82&"
import script from "./roomList.vue?vue&type=script&lang=js&"
export * from "./roomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports